import { render, staticRenderFns } from "./HistoryUser.vue?vue&type=template&id=46ceafde&scoped=true&"
import script from "./HistoryUser.vue?vue&type=script&lang=js&"
export * from "./HistoryUser.vue?vue&type=script&lang=js&"
import style0 from "./HistoryUser.vue?vue&type=style&index=0&id=46ceafde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ceafde",
  null
  
)

export default component.exports